module.exports = __webpack_public_path__ + "img/logo_dark.41400b97.svg";